import React from 'react'
import { useAuth } from '../AuthProvider'
import { useI18n } from '../../i18n'
import { API_ENDPOINTS } from '../../config/api'
import { safeJson } from '../../lib/utils'
import intelStyles from '../../styles/components/assets/AssetsInventoryIntelligence.module.scss'

interface Props {
  assetId: string | number
}

export default function AssetScansSection({ assetId }: Props) {
  const { t } = useI18n()
  const { token } = useAuth()
  const [loading, setLoading] = React.useState(true)
  const [scans, setScans] = React.useState<Array<{ id: string; status?: string; createdAt?: string; healthScore?: number }>>([])

  React.useEffect(() => {
    if (!token) return
    let cancelled = false
    fetch(`${API_ENDPOINTS.ASSETS}/${encodeURIComponent(String(assetId))}/scans`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => safeJson(res))
      .then((data) => {
        if (!cancelled) setScans(Array.isArray(data) ? data : data?.data || [])
      })
      .catch(() => {
        if (!cancelled) setScans([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [token, assetId])

  if (loading) return <p>{t('common.loading')}</p>
  if (!scans.length) {
    return <p className="text-sm text-gray-500">{t('assets.assetPassport.scansEmpty', 'No scan history for this asset.')}</p>
  }

  return (
    <table className={intelStyles.scanTable}>
      <thead>
        <tr>
          <th>{t('assets.assetPassport.scanStatus', 'Status')}</th>
          <th>{t('assets.assetPassport.scanHealth', 'Health')}</th>
          <th>{t('assets.assetPassport.scanDate', 'Date')}</th>
        </tr>
      </thead>
      <tbody>
        {scans.map((s) => (
          <tr key={s.id}>
            <td>{s.status || '—'}</td>
            <td>{s.healthScore != null ? `${s.healthScore}%` : '—'}</td>
            <td>{s.createdAt ? new Date(s.createdAt).toLocaleString() : '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
